import React from 'react';
import PropTypes from 'prop-types';

import { X } from 'react-feather';

import classnames from 'classnames';
import s from './UpdoxPill.css';


/**
 * Updox pill component
 *
 * @param className Optional CSS class to pass into the pill
 * @param content The message of the pill
 * @param qaId Optional string that functions similar to an ID for QA to find the element with ease.
 * @param onRemove Function callback when the remove button is pressed
 * @param removeButton Placement of the removeButton.
 *        Possible values:
 *          true: (default) shows the remove button on the right side
 *          false: hides the remove button
 *          'left': puts the remove button on the left side of the pill
 * @param style: Optional object representation of CSS styles for the pill
 */
const UpdoxPill = ({ className, content, qaId, onRemove, removeButton, style }) => (
  <div
    className={classnames({
      [className]: !!className,
      [s.component]: true,
      [s.leftRemoveButton]: removeButton && removeButton === 'left',
      [s.hiddenRemoveButton]: removeButton != null && !removeButton,
    })}
    data-qa={qaId}
    style={style}
  >
    <span>{content}</span>
    <button
      onClick={event => onRemove && onRemove(event)}
      type="button"
    >
      <X size={16} />
    </button>
  </div>
);

UpdoxPill.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
  qaId: PropTypes.string,
  onRemove: PropTypes.func,
  removeButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  style: PropTypes.object
};

export default UpdoxPill;
